const breakpoints = {
    values: {
        xs: 0,
        sm: 600,
        md: 768,
        lg: 1024,
        xl: 1280,
    },
};

export default breakpoints;
